import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { motion } from "framer-motion";

export default function FAB() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.1, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-5 right-5 z-40 lg:hidden"
    >
      <Link
        to="/contact"
        data-testid="fab-book-assessment"
        aria-label="Book a Free Assessment"
        className="btn-primary shadow-[0_8px_24px_rgba(31,95,255,0.35)]"
      >
        <CalendarCheck size={18} /> Book Assessment
      </Link>
    </motion.div>
  );
}
